import { pdf, Font, Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer'
import logo from '../../assets/logo.png'
import side from '../../assets/side.png'
import robotoRegular from '../../assets/roboto/regular.ttf'
import robotoBold from '../../assets/roboto/bold.ttf'
import robotoLight from '../../assets/roboto/light.ttf'
import { getFecha } from '../helpers'

Font.register({ family: 'Roboto', fonts: [
  { src: robotoRegular },
  { src: robotoBold, fontWeight: 700 },
  { src: robotoLight, fontWeight: 300 },
]});

const css = StyleSheet.create({
  page: {
    flexDirection: 'row',
    backgroundColor: '#E4E4E4',
    fontFamily: 'Roboto'
  },
  side: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: 70,
    height: 842,
  },
  bold: {
    fontWeight: 700,
  },
  section: {
    margin: 10,
    padding: 10,
    paddingLeft: 80,
    fontSize: 12,
  },
  logo: {
    height: 50,
    width: 216,
  },
  main: {
    fontSize: 16,
    marginTop: 15,
    marginBottom: 5,
  },
  title: {
    fontSize: 14,
    fontWeight: 700,
    marginTop: 10,
    marginBottom: 15,
    textDecoration: 'underline',
  },
  element: {
    marginLeft: 10,
    marginBottom: 5,
  },
  subelement: {
    marginLeft: 20,
    marginBottom: 5,
  },
  detail: {
    marginLeft: 30,
    marginBottom: 5,
  },
  notes: {
    marginTop: 40,
    marginBottom: 30,
  },
  note: {
    marginBottom: 10,
  },
  signatures: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 20,
    marginBottom: 40,
  },
  signature: {
    fontSize: 10,
  },
  source: {
    height: 50,
    width: 125,
  },
}) 

const processPDF = ({ nombre, centro, fecha, firmaAlumno, firmaTutor })=> (
  <Document>
    <Page size="A4" style={css.page}>
      <Image fixed style={css.side} src={side} />
      <View style={css.section}>
        <Image style={css.logo} src={logo} />
        <Text style={css.main}>Condiciones de contratación de <Text style={css.bold}>mundoestudiante</Text></Text>

        <View style={css.subsection}>
          <Text style={css.title}>Matricula</Text>
          <Text style={css.element}>• El pago de la matrícula, obligatorio y no reembolsable, asciende a 49€ y debe realizarse el primer día de clases.</Text>
          <Text style={css.element}>• La matrícula caducará a los 2 meses desde la última clase recibida. No se devolverá su importe bajo ningún concepto.</Text>
          <Text style={css.element}>• No se tendrá en cuenta para la caducidad de la matrícula los meses de julio y agosto.</Text>
        </View>

        <View style={css.subsection}>
          <Text style={css.title}>Horario</Text>
          <Text style={css.element}>• La flexibilidad horaria permite a los alumnos acordar el horario de clases con el centro.</Text>
          <Text style={css.element}>• Para algunas modalidades de contratación, existen limitaciones específicas de horario:</Text>
          <Text style={css.subelement}>• La Tarifa Prepara Mañanas solo permite clases en horario de mañanas.</Text>
          <Text style={css.subelement}>• La Tarifa Prepara Tardes solo permite clases en horario de tardes.</Text>
          <Text style={css.element}>• Consulta nuestra política de aperturas y posibles cambios de horario en festivos locales o nacionales. (Revisa nuestra <Text sytle={css.bold}>Política de cambios</Text>)</Text>
          <Text style={css.element}>• <Text sytle={css.bold}>Nota importante:</Text> Las clases online mediante la plataforma de Classfy se rigen por el calendario de la ciudad de Madrid, España.</Text>
        </View>

        <View style={css.subsection}>
          <Text style={css.title}>En el aula</Text>
          <Text style={css.element}>• Se requiere que el alumno se presente con folios en blanco y bolígrafo para las clases. En el caso de asignaturas de ciencias se solicita también calculadora.</Text>
          <Text style={css.element}>• El alumno debe seguir las indicaciones del docente y mantener un comportamiento respetuoso en todo momento. Conductas disruptivas pueden llevar a medidas disciplinarias, incluida la suspensión del servicio.</Text>
        </View>

        <View style={css.subsection}>
          <Text style={css.title}>Política de pagos y devoluciones</Text>
          <Text style={css.element}>• Todos los servicios deben ser abonados por adelantado. El centro se reserva el derecho de no permitir el acceso a clases si los servicios contratados no han sido abonados.</Text>
          <Text style={css.element}>• Si el servicio contratado es una Tarifa (exceptuando la <Text style={css.bold}>Tarifa Base</Text>), la fecha para realizar el pago mensual es hasta el día 5 del mes que se ofrece el servicio.</Text>
          <Text style={css.subelement}>• Las tarifas (exceptuando la <Text style={css.bold}>Tarifa Base</Text>) se renuevan automáticamente de forma mensual. Para darse de baja se deberá notificar dicha baja con 5 días de antelación al inicio del mes; de lo contrario, se abonará el mes completo.</Text>
          <Text style={css.element}>• Si el servicio contratado es un Packs de horas que se oferta a lo largo del año, el pago se realizará el primer día de asistencia a clase. Puedes consultar en secretaría los diferentes periodos de caducidad en función del número de horas contratado</Text>
          <Text style={css.element}>• Los importes realizados a cuenta no son reembolsables. Se otorgará un bono por horas pagadas, válido en el siguiente mes, solo para el cliente original.</Text>
          <Text style={css.element}>• Las clases presenciales canceladas se podrán ofrecer en modalidad online, sin derecho a reembolso, tras coordinación con el alumno.</Text>
        </View>
      </View>
    </Page>
    <Page size="A4" style={css.page}>
      <Image fixed style={css.side} src={side} />
      <View style={css.section}>

        <View style={css.subsection}>
          <Text style={css.title}>Política de cambios</Text>
          <Text style={css.element}>• En caso de cambios o ausencias, el alumno debe notificar al centro con al menos 1 día laborable de antelación.</Text>
          <Text style={css.element}>• En caso de avisar en el plazo establecido:</Text>
          <Text style={[css.subelement, css.bold ]}>• Tarifa Refuerza</Text>
          <Text style={css.detail}>• El alumno tendrá derecho a cambiar horas abonando 2,5€ por hora, sujeto a disponibilidad en el aula (incluido festivos).</Text>
          <Text style={css.detail}>• Si no hay disponibilidad en el aula habitual, las clases podrán recuperarse en otro centro, coordinando previamente.</Text>
          <Text style={css.detail}>• En caso de coincidir las clases con días festivos, las horas de clase podrán ser recuperadas siguiendo la política de cambios anteriormente enunciada. La recuperación será de carácter opcional, solo si el cliente lo desea.</Text>
          <Text style={[css.subelement, css.bold ]}>• Tarifa Base / Pack horas</Text>
          <Text style={css.detail}>• Podrá mover horas a otra fecha y horario, sujeto a disponibilidad de aula.</Text>
          <Text style={css.detail}>• Si no hay disponibilidad en el aula habitual, las clases podrán recuperarse en otro centro, coordinando previamente.</Text>
          <Text style={css.element}>• Fuera del plazo establecido o sin previo aviso:</Text>
          <Text style={[css.subelement, css.bold ]}>• Tarifa refuerza:</Text>
          <Text style={css.detail}>El alumno perderá las horas sin posibilidad de recuperación.</Text>
          <Text style={[css.subelement, css.bold ]}>• Tarifa Base / Pack horas:</Text> 
          <Text style={css.detail}>El alumno perderá las horas sin posibilidad de cambios ni reembolsos.</Text>
        </View>
        
        <View style={css.subsection}>
          <Text style={css.title}>Periodo de desisitimiento</Text>
          <Text style={css.element}>• El cliente dispone de 14 días naturales para ejercer el derecho de desistimiento.</Text>
          <Text style={css.element}>• En caso de desistimiento, las clases ya disfrutadas se facturarán a 20€ por hora, según los servicios prestados.</Text>
          <Text style={css.element}>• La matrícula, siendo un cargo no reembolsable, no está sujeta a devolución en ninguna circunstancia.</Text>
        </View>

        <View style={css.notes}>
          <Text style={css.note}>Las clases impartidas no conducen a la obtención de un título con valor oficial.</Text>
          <Text style={css.note}>Mediante el pago de la matrícula o bono, el cliente manifiesta entender y aceptar estas condiciones.</Text>
        </View>

        <View style={css.signatures}>
          <View style={css.signature}>
            <Text>Firma de {nombre}</Text>
            <Image style={css.source} src={firmaAlumno} />
          </View>
          {firmaTutor && (
            <View style={css.signature}>
              <Text>Firma del tutor</Text>
              <Image style={css.source} src={firmaTutor} />
            </View>
          )}
        </View>

        <Text>Firmado en {centro.nombre}, el {fecha}</Text>
      </View>
    </Page>
  </Document>
)

export const getPDF = async ({ nombre, centro, firmaAlumno, firmaTutor })=> {
  const fecha = getFecha()
  const document = await processPDF({ nombre, centro, fecha, firmaAlumno, firmaTutor })
  const blob = await pdf(document).toBlob()
  return blob
}

export const downloadBlob = (blob)=> {
  const blobUrl = URL.createObjectURL(blob)
  // Create a link element
  const link = document.createElement("a")
  // Set link's href to point to the Blob URL
  link.href = blobUrl
  link.download = 'condiciones.pdf'
  // Append link to the body
  document.body.appendChild(link)
  // Dispatch click event on the link
  link.dispatchEvent(
    new MouseEvent('click', { 
      bubbles: true, 
      cancelable: true, 
      view: window 
    })
  )
  // Remove link from body
  document.body.removeChild(link)
}